import { FC } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { TextAreaWithValidation } from './TextAreaWithValidation';

export interface ITextarea {
  name: string;
  label?: string;
  placeholder?: string;
  value?: string;
  error?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isShadow?: boolean;
  control: any;
  rules?: IRules;
  onBlur?: () => void;
  onChange?: (arg: string) => void;
}

interface IRules {
  required?: string;
  validate?: (value: string) => any;
}

const Textarea: FC<ITextarea> = (props): JSX.Element => {
  const { name, control, onChange, onBlur, rules } = props;
  useForm({ mode: 'onBlur' });

  return (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => {
          return (
            <TextAreaWithValidation
              {...props}
              value={field.value}
              onChange={(value) => {
                field.onChange(value);
                onChange && onChange(value);
              }}
              onBlur={onBlur}
              error={fieldState.error?.message}
            />
          );
        }}
      />
  );
};

export { Textarea };